import axios from 'axios';
import _ from 'lodash';

const templatesStore = {
  state: {
    templates: [],
    loading: false,
  },

  mutations: {
    setTemplates(state, templates) {
      state.templates = templates;
      state.loading = false;
    },

    setTemplate(state, template) {
      const templates = [...state.templates];
      const index = _.findIndex(templates, { id: template.id });

      if (index === -1) {
        templates.push(template);
      } else {
        templates[index] = template;
      }

      state.templates = templates;
      state.loading = false;
    },

    deleteTemplate(state, id) {
      state.templates = state.templates.filter(template => template.id !== id);
      state.loading = false;
    },

    setLoading(state, value) {
      state.loading = value;
    },
  },

  getters: {
    getTemplates: state => state.templates,
  },

  actions: {
    async getTemplates(context) {
      try {
        const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
        const options = {
          headers: {
            Authorization: jwtToken,
          },
        };

        context.commit('setLoading', true);

        const templates = await axios.get(`${window.BASE_API.EMAIL}/templates`, options)
          .then(response => response.data);

        context.commit('setTemplates', templates);
        context.commit('setLoading', false);
      } catch (err) {
        console.error(err);
      }
    },

    createTemplate(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .post(`${window.BASE_API.EMAIL}/templates`, data, options)
        .then((res) => {
          context.commit('setTemplate', res.data);
          context.commit('setLoading', false);
        });
    },

    updateTemplate(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .put(`${window.BASE_API.EMAIL}/templates/${data.id}`, data, options)
        .then((res) => {
          context.commit('setTemplate', res.data);
          context.commit('setLoading', false);
        });
    },

    deleteTemplate(context, id) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .delete(`${window.BASE_API.EMAIL}/templates/${id}`, options)
        .then(() => {
          context.commit('deleteTemplate', id);
          context.commit('setLoading', false);
        });
    },
  },
};

export default templatesStore;



// WEBPACK FOOTER //
// ./src/store/templates/templatesStore.js